// The fallback for /faq/list?section=ai-mentions: what the page shows until the
// admin publishes questions of its own, and whenever that request fails or comes
// back empty. `answer` is rendered as HTML, exactly like a published one.
export interface AiMentionsFaqItem {
    id: string;
    question: string;
    answer: string;
}

const aiMentionsFaqItems: AiMentionsFaqItem[] = [
    {
        id: 'what',
        question: 'מה זה שירות AI Mentions, ולמי זה מתאים?',
        answer: 'AI Mentions הוא השירות שדואג שהעסק שלכם יופיע כשמשתמשים שואלים כלים כמו ChatGPT, Gemini או Claude שאלות רלוונטיות לתחום שלכם. בדיוק כמו שקישורים בונים מוניטין בגוגל, אזכורים בונים מוניטין במנועי בינה מלאכותית. מתאים לבעלי עסקים, מנהלי שיווק וסוכנויות SEO שרוצים להיות חלק מהתשובה שהלקוח מקבל, לא רק מתוצאת החיפוש.',
    },
    {
        id: 'guarantee',
        question: 'זה מבטיח שיזכירו את העסק שלי?',
        answer: 'כמו בכל עבודת קידום רצינית, אין הבטחות ריקות. מה שכן: כל אזכור נבנה סביב שאלה ספציפית שבחרתם, עם קישור למותג שלכם ומיקום מכוון בתוכן, בדיוק לפי ההנחיות שתמסרו לנו בהזמנה.',
    },
    {
        id: 'time',
        question: 'תוך כמה זמן האזכור עולה?',
        answer: 'ברירת המחדל היא 7 ימי עבודה מרגע ההזמנה, בדיוק כמו הזמנת מאמר. תקבלו עדכון בסטטוס ההזמנה שלכם באזור האישי ברגע שהאזכור עולה.',
    },
    {
        id: 'tracking',
        question: 'איך אני עוקב אחרי ההזמנה שלי?',
        answer: 'את הסטטוס של כל הזמנה, מרגע היצירה ועד לפרסום בפועל, אפשר לראות בכל רגע באזור האישי שלכם במערכת (התקבלה, בכתיבה, באוויר). בדיוק כמו במעקב אחרי הזמנת מאמר.',
    },
    {
        id: 'alongside-links',
        question: 'אני צריך את זה בנוסף לקישורים, או במקום?',
        answer: 'בנוסף. קישורים בונים את הסמכות שהאתר שלכם צריך; AI Mentions דואג שהסמכות הזו תגיע גם לתשובה שהלקוח מקבל מה-AI.',
    },
    {
        id: 'commitment',
        question: 'יש התחייבות מינימלית לרכישת אזכורים?',
        answer: 'לא, כמו בכל Link&Go, זה שירות self-service. רוכשים חבילת אזכורים לפי הצורך, בלי מנוי ובלי התחייבות חודשית.',
    },
];

export default aiMentionsFaqItems;
